import { render, staticRenderFns } from "./DialogFormInput.vue?vue&type=template&id=af58489c"
import script from "./DialogFormInput.vue?vue&type=script&lang=js"
export * from "./DialogFormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports